import cv from 'opencv.js';

// Copyright (c) Meta Platforms, Inc. and affiliates.
// All rights reserved.

// This source code is licensed under the license found in the
// LICENSE file in the root directory of this source tree.

function rgbaStringSplit(stringColor) {
  const rgbaColorArr = stringColor.match(/\d+/g).map((number) => parseInt(number));
  const r = rgbaColorArr[0];
  const g = rgbaColorArr[1];
  const b = rgbaColorArr[2];
  const a = rgbaColorArr[3];
  return [r, g, b, a];
}

// Convert the onnx model mask prediction to ImageData
// maskColor  : 'rgba(255,255,255,1)';
function arrayToImageData(input, width, height, maskColor) {
  const [r, g, b, a] = rgbaStringSplit(maskColor);
  // console.log(width,height)
  const arr = new Uint8ClampedArray(4 * width * height).fill(0);
  for (let i = 0; i < input.length; i++) {
    // Threshold the onnx model mask prediction at 0.0
    // This is equivalent to thresholding the mask using predictor.model.mask_threshold
    // in python
    if (input[i] > 0.0) {
      arr[4 * i + 0] = r;
      arr[4 * i + 1] = g;
      arr[4 * i + 2] = b;
      arr[4 * i + 3] = 120;
    }
  }

  // const position = imageDataPosition(input, width, height);
  // const testArr = arr.slice(position.start.x * position.start.y, position.end.x * position.end.y);
  // const testWidth = position.end.x - position.end.y;
  // const testHeight = position.end.y - position.start.y;
  // console.log(testWidth,testHeight)
  return new ImageData(arr, height, width);
}

function imageDataToJSON(imageData) {
  const { width, height, data } = imageData;
  const jsonImage = {
    width,
    height,
    data: Array.from(data),
  };
  return JSON.stringify(jsonImage);
}

// Use a Canvas element to produce an image from ImageData
function imageDataToImage(imageData) {
  const canvas = imageDataToCanvas(imageData);
  const image = new Image();
  image.src = canvas.toDataURL();
  return image;
}

// Canvas elements can be created from ImageData
function imageDataToCanvas(imageData) {
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  canvas.width = imageData.width;
  canvas.height = imageData.height;
  ctx?.putImageData(imageData, 0, 0);
  return canvas;
}

// export function base64ImageToElement(imageData) {
//   //  const canvas = document.createElement('canvas');
//   //  const ctx = canvas.getContext('2d');
//   let img = document.createElement('img');
//   img.onload = function (image) {
//     console.log('base64ImageToElement', img);
//     let mat = cv.imread(img);
//     // console.log('base64ImageToElement', mat);
//     // 여기서부터 OpenCV.js 코드를 작성하면 됩니다.
//   };
//   img.src = imageData;
//   return img;
// }

// 이미지 내부 객체의 시작과 끝 좌표 구하기
// function imageDataPosition(input: any, width: number, height: number) {
//   let startX = -1;
//   let startY = -1;
//   let endX = -1;
//   let endY = -1;

//   for (let y = 0; y < height; y++) {
//     for (let x = 0; x < width; x++) {
//       const index = (y * width + x);

//       if (input[index] > 0.0) {
//         startX = x;
//         startY = y;
//         break;
//       }
//     }
//     if (startX !== -1) break; // 이미 찾았으면 중지
//   }
//   for (let y = height - 1; y >= 0; y--) {
//     for (let x = width - 1; x >= 0; x--) {
//       const index = (y * width + x);

//       // 빨간색이면 마지막 좌표로 설정
//       if (input[index] > 0.0) {
//         endX = x+3;
//         endY = y+3;
//         break;
//       }
//     }
//     if (endX !== -1) break; // 이미 찾았으면 중지
//   }
//   return {
//     start: {
//       x: startX,
//       y: startY
//     },
//     end: {
//       x: endX,
//       y: endY
//     }
//   }
// }

// Convert the onnx model mask output to an HTMLImageElement
export function onnxMaskToImage(input, width, height, maskColor) {
  const resultImage = arrayToImageData(input, width, height, maskColor);

  return imageDataToImage(resultImage);
  // return resultImage;
}
